import type { ComponentType, JSX, ReactNode } from "react";

interface LogoProps {
  className?: string;
  href?: "/";
  size?: "default" | "sm";
  LinkComponent?: ComponentType<{
    href: "/";
    className?: string;
    children?: ReactNode;
  }>;
}

export function Logo({
  className = "",
  href = "/",
  size = "default",
  LinkComponent,
}: LogoProps): JSX.Element {
  const isSmall = size === "sm";
  const content = (
    <>
      <img
        src="https://sum.video/icon128.png"
        alt="sum.video logo"
        className={isSmall ? "h-6 w-6" : "h-8 w-8"}
      />
      <span
        className={
          isSmall
            ? "text-base font-bold tracking-tight text-foreground"
            : "text-xl font-bold tracking-tight text-foreground"
        }
      >
        sum.video/
      </span>
    </>
  );

  const wrapperClassName = `flex items-center space-x-2 hover:opacity-80 transition-opacity ${className}`;

  if (LinkComponent) {
    return (
      <LinkComponent href={href} className={wrapperClassName}>
        {content}
      </LinkComponent>
    );
  }

  return (
    <a href={href} className={wrapperClassName}>
      {content}
    </a>
  );
}
